/**
* Featured Blog JS
* -----------------------------------------------------------------------------
*
* All the JS for the Featured Blog component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
import Splide from '@splidejs/splide';
( function( app ) {
  const COMPONENT = {

    className: 'featured-blog',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      $( '.featured-blog' ).each( function( key, component ) {
        const inner = $( component ).find( '.featured-blog__inner' )[0];
        const inactivePanelWidth = 400;
        const activePanelWidth = 600;
        const totalMargin = 20 * ( $( component ).find( '.featured-blog__post--real' ).length - 1 );
        const totalWidth = ( inactivePanelWidth * ( $( component ).find( '.featured-blog__post--real' ).length - 1 ) ) + activePanelWidth;
        const pinnedAmount = totalWidth + activePanelWidth;
        const averagePanelWidth = totalWidth / $( component ).find( '.featured-blog__post--real' ).length;
        const averagePanelWidthAndMargin = averagePanelWidth + totalMargin;

        const pinner = gsap.timeline( {
          scrollTrigger: {
            trigger: $( component ).find( '.featured-blog__desktop' )[0],
            pin: true,
            start: 'top ' + topOffset,
            end: '+=' + pinnedAmount,
            scrub: 2,
          },
        } );

        const $posts = $( '.featured-blog__post--real' );
        const count = $posts.length;
        const topOffset = $( '#wpadminbar' ).length ? $( '#wpadminbar' ).height() : 0;
        const xPx = $( '.featured-blog__slider' )[0].scrollWidth / 2;
        let lastIndex = -1;

        gsap.to( '.featured-blog__slider', {
          x: ( ( xPx - ( averagePanelWidthAndMargin - 20 ) ) * -1 ),
          ease: 'none',
          scrollTrigger: {
            trigger: inner,
            scrub: 1,
            start: 'top ' + topOffset,
            end: '+=' + totalWidth,
            onUpdate: function( e ) {
              const adjustedProgress = e.progress;
              let index = Math.floor( adjustedProgress * count );
              if ( index >= count ) index = count - 1;

              if ( index === lastIndex ) return;

              $posts.removeClass( 'is-active' );
              $posts.eq( index ).addClass( 'is-active' );
              lastIndex = index;
            },
          },
        } );
      } );

      $( '.featured-blog__mobile' ).each( function( key, component ) {
        const splide = new Splide( $( component ).find( '.splide--featured-blog' )[0], {
          type: 'loop',
          pagination: false,
          arrows: false,
          gap: '24px',
          perPage: 1,
          centerMode: true,
        } );

        splide.mount();
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'featured-blog', COMPONENT );
} )( app );
